// export const baseUrl = process.env.REACT_APP_BASE_URL;
// export const baseUrl = "https://femade-api.advicera.cf";

export const baseUrl = "https://api.femade.org.ua";
